module.exports = __webpack_public_path__ + "img/logo-codata.b451b038.png";